import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import { toast } from "react-toastify";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import useColumns from "./hooks/useColumns";
import useTAM from "./hooks/useTAM";
import useCobranca from "./hooks/useCobranca";
import useItinerancia from "./hooks/useItinerancia";
import constants from "../../Constants";

const OutrasAcoesFiscais = ({ dadosOs }) => {
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const { columns } = useColumns();
  const { request, data, errors, isLoading } = useApiClient();

  const { listaTAM } = useTAM(dadosOs.acaoFiscal);
  const { listaCobranca } = useCobranca(dadosOs.sqContribuinte, dadosOs.sqPessoa);
  const { listaItinerancia } = useItinerancia(dadosOs.sqPessoa);

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const requestDadosOsHandler = useCallback(() => {
    if (dadosOs.acaoFiscal !== "" || dadosOs.acaoFiscal !== undefined) {
      const values = {
        SqAcaoFiscal: dadosOs.acaoFiscal,
        SqContribuinte: dadosOs.sqContribuinte,
        SqPessoa: dadosOs.sqPessoa,
        pageSize,
        pageNumber,
      };

      request(apiRoutes.fiscalizacao.ordemservico.outrasAcoesFiscais, values);
    }
  }, [dadosOs, pageSize, pageNumber, request]);

  useEffect(() => {
    requestDadosOsHandler();
  }, [requestDadosOsHandler]);

  useEffect(() => {
    if (data?.result) {
      setRows(data.result || []);
      setTotalRows(data.result.length ? data.result.length : 0);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  return (
    <div style={{ width: "100%" }}>
      <Row>
        <Col>
          <h5>OS</h5>
          <DataTable
            noHeader
            keyField="sqAndamento"
            columns={columns}
            data={rows}
            progressPending={isLoading}
            noDataComponent="Não existem registros."
            progressComponent={<TextSpinner />}
            defaultSortFieldId={1}
            sortIcon={<BsArrowDown />}
            pagination
            paginationServer
            sortable
            paginationTotalRows={totalRows}
            pointerOnHover
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={constants.paginationComponentOptions}
            paginationPerPage={pageSize}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 15 }}>
        <Col>{listaCobranca}</Col>
      </Row>

      <Row style={{ marginTop: 15 }}>
        <Col>{listaTAM}</Col>
      </Row>

      <Row style={{ marginTop: 15 }}>
        <Col>{listaItinerancia}</Col>
      </Row>
    </div>
  );
};

export default OutrasAcoesFiscais;
